import React, { Component } from 'react'
import { Input, Button, FormGroup, Label } from 'reactstrap';
import { firebase } from '../utils/firebase';


class forgotPassword extends Component {
    constructor() {
        super()

        this.onHandleChange = this.onHandleChange.bind(this)
        this.submitPasswordReset = this.submitPasswordReset.bind(this)

        this.state = {
            email: '',
            phoneNumber: '',
        }        
    }
   
    
     render(){
        const user = this.state.currentUser;
        return (
          <div>           
            <h3>Reset Your Password</h3>
                <br/>
                <FormGroup style={{ display: 'flex', flexDirection: 'column', maxWidth:'300px', margin: 'auto', width: '50%', justifyContent: 'center', alignSelf: 'center' }}> 
                <Input type="email" name="email" maxLength="50" id="email" placeholder="Email" onChange={this.onHandleChange} />
                <br/>
                <Input type="phoneNumber" name="phoneNumber" id="phoneNumber" placeholder="Phone Number" onChange={this.onHandleChange} />
                <br/>
                <Button onClick={this.submitPasswordReset}>Reset Password</Button>
                </FormGroup>   
          </div>
                  
        )//return
    }

    onHandleChange(e) {
        var value = e.target.value;
        var name = e.target.name;
      this.setState({
        [name]: value,
      })
    }

    //this function validates the user info is real and then sends a password reset email
    submitPasswordReset(){
        
        var db = firebase.firestore();
        var email = this.state.email; //store user email into a variable so we can use it in functions later

        //set firebase location
        var location = db.collection('users').where('email','==', email).where('phoneNumberPrimary','==', this.state.phoneNumber);

        //first sign in to the database
        firebase.auth().signInAnonymously().catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
          }).then(()=>{
            //now query the database for the user with that info
            location.get().then(function(querySnapshot) {
              //if the document doesn't exist, notify the user that we couldn't find the account
                if(querySnapshot.empty){
                  alert('We were unable to find an account with that email and phone number. \nIf you think there is an error, please contact the VERFID customer support team at support@verfidpet.com.');
                }
                //if the document exists, go ahead and send a password reset email
                else{
                  firebase.auth().sendPasswordResetEmail(email).then(function()
                  {
                    alert('A password reset link was sent to your email! \nPlease follow the steps in the email to complete the password reset process.');
                  })
                  .catch(function(error){
                    alert('Your account info was recognized but there was an error resetting the password. Pleases contact the VERFID support team with questions at support@verfidpet.com.');
                  })
                }
            });
            
          })           
      }
}

export default forgotPassword


// WEBPACK FOOTER //
// ./src/components/forgotPassword.js